import ApiClient from './client/ApiClient'

export const getArticle = ({ articleId }) =>
  ApiClient.client.get(`/v2/articles/${articleId}`)
    .then(response => response)
    .catch(err => ({ err }))
